<template>
  <navbar-menu-tool
    v-model="isMenuOpen"
    :menu-data="{ name, position: 'left', allowOtherTop: true }"
    :button-bind="{ icon, iconSize: '20', tooltip, verboseName: tooltip }"
    has-close-header
  >
    <template #content>
      <div class="ma-2 text-body-2">
        <v-row no-gutters align="start" class="flex-nowrap">
          <v-col cols="auto" class="flex-grow-1">
            <data-input v-model="value" v-bind="searchInputBind" @click:clear="clear" />
          </v-col>
          <v-col cols="auto" class="pl-2">
            <base-button
              class="mr-0 mt-1"
              icon="mdi-magnify"
              icon-size="22px"
              :button-style="{
                backgroundColor: !searching ? $_colors.primary : 'rgb(210, 210, 210)',
                iconColor: 'white',
                borderRadius: '6px',
              }"
              is-icon
              :disabled="searching"
              @click="search()"
            />
          </v-col>
        </v-row>
        <ribbon-list
          v-if="results?.length > 1"
          class="mt-3"
          :list-items="results"
          item-title-key="properties.teryt"
          :toggleable="false"
          style-type="rawShadow"
          @mouseenter="() => {}"
          :clickable-listeners="[]"
        >
          <template #itemButtons-append="{ item }">
            <v-icon size="17" color="primary" @click="zoomTo(item)">mdi-magnify</v-icon>
          </template>
        </ribbon-list>
      </div>
    </template>
  </navbar-menu-tool>
</template>
<script>
import { call } from 'vuex-pathify';
import { WKT } from 'ol/format';
import { prepareDrawnFeature } from '@/assets/js/mapUtils';

import { Fill, Stroke, Style, Text } from 'ol/style';

import DataInput from '@/components/DataInput';
import NavbarMenuTool from '@/components/NavbarMenuTool';
import RibbonList from '@/components/RibbonList';

export default {
  name: 'TheNavbarToolsPanelSimpleParcelsSearch',
  components: { DataInput, NavbarMenuTool, RibbonList },
  props: {
    icon: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    tooltip: {
      type: String,
    },
  },
  computed: {
    searchInputBind() {
      return {
        dataType: { name: 'text' },
        prependInnerIcon: 'mdi-magnify',
        placeholder: this.$i18n.t('default.find'),
        clearable: true,
        hint: this.$i18n.t('sidebar.uldk.simpleSearchHint'),
        loading: this.searching,
      };
    },
  },
  data: () => ({
    isMenuOpen: false,
    searching: false,
    results: [],
    value: '',
  }),
  methods: {
    searchUldkSimpleParcel: call('search/searchUldkSimpleParcel'),
    async search(value = this.value) {
      this.searching = true;
      this.clear();
      try {
        this.results = (await this.searchUldkSimpleParcel({ value, geojsonLikeWithMapping: true })).map(feature => {
          let wktText = feature.geometry;
          if (wktText.indexOf(';') >= 0) wktText = wktText.split(';')[1];
          const olFeature = new WKT().readFeature(wktText, {
            dataProjection: this.$_config.defaultEpsg,
            featureProjection: this.$_config.defaultEpsg,
          });
          return { ...prepareDrawnFeature(olFeature), properties: feature.properties };
        });
        this.$root.$emit('toggleCustomVectorLayer', {
          id: 'simple-parcels-search',
          geometry: { features: this.results, type: 'FeatureCollection' },
          layerParams: {
            style: feature => {
              return new Style({
                stroke: new Stroke({
                  color: 'rgba(191, 54, 12, 1)',
                  width: 2,
                }),
                text: new Text({
                  text: feature.get('teryt'),
                  font: 'normal 14px sans-serif',
                  fill: new Fill({ color: 'rgba(191, 54, 12, 1)' }),
                  stroke: new Stroke({
                    color: '#FFFFFF',
                    opacity: 1,
                    width: 3,
                    dash: [],
                  }),
                  overflow: true,
                }),
              });
            },
          },
        });
        if (this.results.length === 0)
          this.$store.set('snackbar/PUSH_MESSAGE!', {
            message: this.$i18n.t('sidebar.uldk.noResults'),
          });
        else if (this.results.length === 1) this.zoomTo(this.results[0]);
        else
          this.$store.set('snackbar/PUSH_MESSAGE!', {
            message: this.$i18n.t('sidebar.uldk.severalResultsFound'),
          });
      } finally {
        this.searching = false;
      }
    },
    clear() {
      this.results = [];
      this.$root.$emit('toggleCustomVectorLayer', { id: 'simple-parcels-search' });
    },
    zoomTo(element) {
      this.$root.$emit('createGeomAndFitView', element.geometry);
    },
  },
  watch: {
    value: {
      handler(nV) {
        if (!nV) this.clear();
      },
    },
  },
};
</script>
